import { render, staticRenderFns } from "./OutwardFreightMainSection.vue?vue&type=template&id=98da4194"
import script from "./OutwardFreightMainSection.vue?vue&type=script&lang=js"
export * from "./OutwardFreightMainSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports